import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {useScroll, useReducedMotion, motion, useTransform} from 'framer-motion'

const MediaAnimation = ({children, layout = 'full-width'}) => {
    const ref = useRef(null)
    const shouldReduceMotion = useReducedMotion()
    const {scrollYProgress} = useScroll({
        target: ref,
        offset: ['0 0.8', 'end end']
    })

    const scale = useTransform(scrollYProgress, [0, 1], [shouldReduceMotion ? 1 : 0.7, 1])

    const isInline = layout === 'inline'
    const borderRadius = useTransform(
        scrollYProgress,
        [0, 1],
        [shouldReduceMotion ? (isInline ? '12px' : '0px') : '12px', isInline ? '12px' : '0px']
    )

    return (
        <motion.div ref={ref} style={{scale, borderRadius, overflow: 'hidden'}}>
            {children}
        </motion.div>
    )
}

MediaAnimation.propTypes = {
    children: PropTypes.node,
    layout: PropTypes.oneOf(['full-width', 'inline'])
}

export default MediaAnimation
